import PropTypes from "prop-types";
import styled from "styled-components";
import { codeDisplay, hoursPerAccruedHour } from "common/utils/PTO/helpers";

const Details = styled.div`
  padding-bottom: 10px;
`;

export const AccrualDetails = ({ rule }) => {
  const perAccruedHour = hoursPerAccruedHour(rule.accrualRate);

  return (
    <Details>
      <h3>{codeDisplay(rule.code)}</h3>
      <p>
        Accrual Rate:{" "}
        {perAccruedHour === null
          ? "N/A"
          : `1 hr per ${perAccruedHour.toFixed(2)} hours worked`}
      </p>
      <p>Accrual Max Per Year: {rule.accrualMax} hr</p>
      <p>Carryover Limit: {rule.carryoverLimit} hr</p>
      <p>
        Yearly Usage Limit:{" "}
        {rule.usageMax === null ? "N/A" : `${rule.usageMax} hr`}
      </p>
      <p>Type: {rule.percentPayout > 0 ? "Paid" : "Unpaid"}</p>
    </Details>
  );
};

AccrualDetails.propTypes = {
  rule: PropTypes.shape({
    code: PropTypes.string,
    carryoverLimit: PropTypes.number,
    usageMax: PropTypes.number,
    accrualMax: PropTypes.number,
    accrualRate: PropTypes.number,
    percentPayout: PropTypes.number,
  }).isRequired,
};
